/**
 * Viewport widths (px) at which a layout switches. In styled templates use the ready `mq` strings
 * (`${theme.mq.desktop} { … }`); the raw numbers are for JS comparisons (navbar width checks, matchMedia).
 */
export const breakpoints = {
  pdpDesktop: 1150, // product page: sticky gallery | info column side by side (Daniel: 850 was far too narrow); also the shop/category page's 2→3 card grid switch and the desktop category menu row
  shopCompact: 450, // PDP gutter step and ProductTile's narrow rows; the category grid itself is auto-fit (2-up on every phone)
  navbarIcons: 500, // account and logout icons: in the mobile menu below, in the header from here (narrower, they touch the logo)
  bannerWide: 700, // homepage "poznaj bliżej": square phone photo → landscape photo (the hotspot positions switch with it)
  /* ends of the fluid type scale (`theme.type` roles): the mobile mock width and the reference desktop */
  typeMin: 360,
  typeMax: 1440,
};

/** media-query strings — the one place for every `@media (min-width: …)`; never redeclare these locally */
export const mq = {
  desktop: `@media (min-width: ${breakpoints.pdpDesktop}px)`,
  shopCompact: `@media (min-width: ${breakpoints.shopCompact}px)`,
  /** the narrow-phone side of the same threshold (ProductTile rows tighten here) */
  belowShopCompact: `@media (max-width: ${breakpoints.shopCompact - 1}px)`,
  /** the mobile side of the desktop threshold (stacked grids that carry dividers only while stacked) */
  belowDesktop: `@media (max-width: ${breakpoints.pdpDesktop - 1}px)`,
  bannerWide: `@media (min-width: ${breakpoints.bannerWide}px)`,
} as const;
